module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menuIcon",
    class: _vm.name,
    attrs: {
      "id": 'menu-' + _vm.name
    },
    on: {
      "click": function($event) {
        return _vm.go()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e5d05ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 817
// module chunks = 0